import React, { useState, useEffect } from "react";
import { resolveConfirm } from "./confirm";
import { AlertTriangle, Trash2 } from "lucide-react";

export default function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    const handler = (e) => setState(e.detail);
    window.addEventListener("nexiora:confirm", handler);
    return () => window.removeEventListener("nexiora:confirm", handler);
  }, []);

  const handle = (result) => {
    resolveConfirm(result);
    setState(null);
  };

  const TIPOS = {
    danger:  { col:"#dc2626", bg:"#fee2e2", border:"#fca5a5", icon:<Trash2 size={22} color="#dc2626"/> },
    warning: { col:"#d97706", bg:"#fef3c7", border:"#fde68a", icon:<AlertTriangle size={22} color="#d97706"/> },
    info:    { col:"#2563eb", bg:"#dbeafe", border:"#93c5fd", icon:null },
  };

  const t = TIPOS[state?.type || "danger"];

  return (
    <>
      {children}
      {state && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
          onClick={e=>e.target===e.currentTarget&&handle(false)}>
          <div style={{background:"#fff",borderRadius:16,padding:28,maxWidth:400,width:"100%",boxShadow:"0 25px 80px rgba(0,0,0,.25)",animation:"cfs .15s ease"}}
            onClick={e=>e.stopPropagation()}>
            <div style={{width:52,height:52,borderRadius:"50%",background:t.bg,border:`1px solid ${t.border}`,display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
              {t.icon}
            </div>
            <h3 style={{fontSize:17,fontWeight:800,color:"#111827",marginBottom:8}}>{state.title}</h3>
            <p style={{fontSize:13,color:"#6b7280",lineHeight:1.6,marginBottom:24,whiteSpace:"pre-line"}}>{state.message}</p>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button onClick={()=>handle(false)}
                style={{padding:"9px 20px",border:"1px solid #e5e7eb",borderRadius:8,background:"#fff",color:"#374151",fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
                {state.cancelLabel || "Annulla"}
              </button>
              <button onClick={()=>handle(true)} autoFocus
                style={{padding:"9px 20px",border:"none",borderRadius:8,background:t.col,color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
                {state.confirmLabel}
              </button>
            </div>
          </div>
          <style>{`@keyframes cfs{from{opacity:0;transform:scale(.94)}to{opacity:1;transform:scale(1)}}`}</style>
        </div>
      )}
    </>
  );
}
